import {createSinglePathSVG} from './TEMPLATE'

export const Wallet_Stroke2_Corner2_Rounded = createSinglePathSVG({
  path: 'M4 6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v1H4V6Zm0 3v9a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9H4Zm13 4a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z',
})
